module.exports = __webpack_public_path__ + "media/application/images/call_to_action/books_row-e0c2137c0b4bb34c09d60fa80e5fb422.png";